import { factorial } from './factorial';
import { BettingSvc } from '../services/betting.service';

/**
 * Format ticket for print
 * @param data
 * @returns {Object}
 */
export const printFormatter = data => {
  const formattedData = data;
  for (let i = 0; i < formattedData.bets.length; i++) {
    const bet = formattedData.bets[i];

    // System tickets don't have info about combinations
    if (bet.system) {
      formattedData.bets[i].totalCombinations = factorial(bet.value.length) / (factorial(bet.system) * factorial(bet.value.length - bet.system));
      formattedData.bets[i].stakePerCombination = bet.amount / bet.totalCombinations;
    }

    const specialBetIds = [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41];
    const specialBets = BettingSvc.getBettingSvc().specialBets;
    if (specialBetIds.indexOf(bet.bet.id) > -1) {
      for (let j in specialBets) {
        if (specialBets[j].id === bet.bet.id) {
          if (bet.bet.id < 40) {
            bet.value = specialBets[j].actions[bet.outcome.value].info.split(' - ')[1];
            bet.value = bet.value.toUpperCase();
            bet.useValue = true;
            bet.odd = specialBets[j].actions[bet.outcome.value].odd;
          } else {
            bet.odd = specialBets[j].actions[bet.value.length - 1].odd;
          }
        }
      }
    }

    if (bet.possibleWin) {
      bet.possibleWin = parseFloat(bet.possibleWin).toFixed(2);
    }
  }

  return formattedData;
};




// WEBPACK FOOTER //
// printFormatter.js